import React, {useRef, useState} from 'react';
import styles from './styles';
import {DataTableContext} from '../../Utils/DataTableContext';
import {ScrollContext} from '../../Utils/ScrollContext';
import {InOutAnimation as Animation} from '@xpertdox_js/xdcomponents';

const InfoModal = props => {

  const {controller} = React.useContext(DataTableContext);
  const {headers} = React.useContext(ScrollContext);
  const [showModal, setShowModal] = useState(false);
  const tipActive = controller.tipIndex !== null;
  if (tipActive && !showModal) setShowModal(true);
  const snapShot = useRef({
    title: '',
    tip: '',
  });

  const tipIndex = controller.tipIndex;
  if (tipIndex !== null) {
    snapShot.current.tip = controller.headers[tipIndex].tip;
    snapShot.current.title = controller.headers[tipIndex].title;
  }


  const containerStyles = {
    ...styles.container,
    position: headers ? 'fixed' : 'absolute',
    marginLeft: headers && props.options.customLeftOffset ? props.options.customLeftOffset / 2 : 0,
    top: headers ? '115px' : '65px',
    // width: controller.tableWidth - 45 + 'px',
  };

  return( showModal ?
    <Animation
      animation={{
        in: [
          ['opacity', {0: 0, 100: 1}, 320],
          ['transform', {0: 50, 100: 0}, 320, {easing: 'easeOut', valueMap: 'translateY($vpx)'}]
        ],
        out: [
          ['opacity', {0: 1, 100: 0}, 320],
          ['transform', {0: 0, 100: 50}, 320, {easing: 'easeIn', valueMap: 'translateY($vpx)'}]
        ],
      }}
      fixedTransform='translateX(-50%)'
      condition={tipActive}
      wrapStyles={containerStyles}
      callback={!tipActive ? () => setShowModal(false) : null}
    >
      <h5 style={styles.title}>{snapShot.current.title}</h5>
      <p style={styles.tip}>{snapShot.current.tip}</p>
    </Animation>
  : null)
}

export default InfoModal;
